import axios from "axios";

// Gerenciar UID para autenticação nos endpoints /upload e /survey
let authUID: string | null = null;

export const setAuthUID = (uid: string) => {
  authUID = uid;
};

export const getAuthUID = () => {
  return authUID;
};

export const clearAuthUID = () => {
  authUID = null;
};

export const api = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
  timeout: 60000, // 60 segundos para uploads grandes
});

// Interceptor para adicionar headers automáticos
api.interceptors.request.use(
  (config) => {
    // Garantir Content-Type UTF-8 para requisições JSON
    if (config.data && !(config.data instanceof FormData)) {
      if (!config.headers["Content-Type"]) {
        config.headers["Content-Type"] = "application/json; charset=utf-8";
      }
    }

    // Adicionar gud-subscription-key em todas as requisições
    if (import.meta.env.VITE_APP_API_SUBSCRIPTION_KEY) {
      config.headers["gud-subscription-key"] =
        import.meta.env.VITE_APP_API_SUBSCRIPTION_KEY;
    }

    // Adicionar Authorization (UID) para endpoints que requerem
    if (authUID && (config.url?.includes("/upload") || config.url?.includes("/survey"))) {
      config.headers["gud-update-key"] = authUID;
    } else if (config.url?.includes("/upload") || config.url?.includes("/survey")) {
      console.warn("Interceptor: Tentando fazer upload/survey sem UID!");
    }

    return config;
  },
  (error) => {
    console.error("Interceptor error:", error);
    return Promise.reject(error);
  }
);
